import Stack from "@mui/material/Stack";
import { Link } from "react-router";
import TextField from "@mui/material/TextField";
import React from "react";
import Button from "@mui/material/Button";
import { FormProvider, useForm } from "react-hook-form";
import InputAdornment from "@mui/material/InputAdornment";
import SelectInput from "../../../../components/Inputs/SelectInput";
import InputLabel from "@mui/material/InputLabel";
import FormHelperText from "@mui/material/FormHelperText";
import ButtonSelectCover from "../../../../components/Button/ButtonSelectCover";
import PaperDialog from "../../../../components/Dialog/PaperDialog";
import LoadingDataAlert from "../../../../components/Alert/LoadingDataAlert";
import SuccessSubmitDataAlert from "../../../../components/Alert/SuccessSubmitDataAlert";
import ErrorSubmitDataAlert from "../../../../components/Alert/ErrorSubmitDataAlert";
import { useData } from "../../../../lib/context/DataContext";

const categories = ["Boeuf", "Veau", "Agneau", "Porc", "Volaille", "Abats"];
const unites = ["Kg", "Pièce"];

export default function GestionAjouterProduit() {
	const methods = useForm({ defaultValues: { categorie: "", unite: "" } });
	const { produits } = useData();

	const [status, setStatus] = React.useState(null);

	const onSubmit = async (data) => {
		setStatus("loading");
		if (data.cover) {
			try {
				const file = data.cover[0];
				const fileName = data.name.replaceAll(/\W/g, "") + ".png";
				const contentType = file.type;

				// Étape 1 — Demander une URL SAS depuis l'API Azure Function
				const res = await fetch("/api/uploadCoverProduit", {
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify({ fileName, contentType }),
				});

				if (!res.ok)
					throw new Error(
						"Erreur lors de la récupération de l’URL SAS"
					);

				const { sasUrl } = await res.json();

				// Étape 2 — PUT du fichier directement dans Azure Blob Storage
				const putRes = await fetch(sasUrl, {
					method: "PUT",
					headers: {
						"x-ms-blob-type": "BlockBlob",
						"Content-Type": contentType,
					},
					body: file,
				});

				if (!putRes.ok)
					throw new Error("Erreur lors de l’envoi sur le blob");

				console.log("✅ Upload réussi !");
			} catch (err) {
				console.error("Erreur upload:", err);
			}
		}

		const nouveauProduit = {
			partitionKey: data.name.replaceAll(/\W/g, ""),
			rowKey: data.name.replaceAll(/\W/g, ""),
			categorie: data.categorie,
			name: data.name,
			unite: data.unite,
			prix: parseFloat(data.prix.replaceAll(",", ".")).toFixed(2),
			cover: data.cover ? true : false,
		};

		try {
			const res = await fetch("/api/addProduit", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(nouveauProduit),
			});

			if (res.ok) {
				setStatus("success");
			} else {
				//const json = await res.json();
				//setErrorMessage(json.error || "Erreur inconnue");
				setStatus("error");
			}
		} catch (err) {
			//setErrorMessage(err.message || "Erreur réseau");
			setStatus("error");
		} finally {
			produits.fetchDataProduits();
		}
	};

	return (
		<FormProvider {...methods}>
			<PaperDialog
				titre="Ajouter un produit"
				onSubmit={methods.handleSubmit(onSubmit)}
				actions={
					!status ? (
						<Button
							variant="contained"
							color="success"
							fullWidth
							type="submit"
						>
							Envoyer
						</Button>
					) : status === "success" ? (
						<>
							<Button
								color="primary"
								size="small"
								variant="contained"
								onClick={() => {
									setStatus(false);
									methods.reset();
								}}
							>
								Ajouter un autre produit
							</Button>
							<Link to="..">
								<Button
									color="error"
									size="small"
									variant="contained"
								>
									Fermer
								</Button>
							</Link>
						</>
					) : (
						<Link to="..">
							<Button
								color="error"
								size="small"
								variant="contained"
							>
								Fermer
							</Button>
						</Link>
					)
				}
			>
				{status === "error" && (
					<ErrorSubmitDataAlert>
						l'ajout du nouveau produit
					</ErrorSubmitDataAlert>
				)}
				{status === "loading" && <LoadingDataAlert />}
				{status === "success" && (
					<SuccessSubmitDataAlert>
						Le produit a été ajouter avec succèss !
					</SuccessSubmitDataAlert>
				)}
				{!status && (
					<Stack spacing={1}>
						<TextField
							variant="standard"
							label="Nom"
							required
							helperText="Indiquer le nom du produit"
							{...methods.register("name")}
						/>
						<SelectInput
							name="Catégorie"
							formValue="categorie"
							helperText="Sélectionner la categorie du produit"
							selectList={categories}
						/>
						<SelectInput
							name="Unité"
							formValue="unite"
							helperText="Sélectionner l'unité de vente"
							selectList={unites}
						/>
						<TextField
							label="Prix"
							variant="standard"
							required
							helperText="Indiquer le prix du produit"
							{...methods.register("prix")}
							slotProps={{
								input: {
									startAdornment: (
										<InputAdornment position="start">
											€/Kg
										</InputAdornment>
									),
									inputMode: "decimal", // Clavier numérique sur mobile
									type: "text", // Accepte , ou .
									pattern: "[0-9]+([,.][0-9]{1,2})?", // Optionnel pour limiter la saisie
								},
							}}
						/>
						<InputLabel>Illustration</InputLabel>
						<ButtonSelectCover />
						<FormHelperText>
							Cliquer sur le bouton pour sélectionner une
							illustration sur votre ordinateur. format carré
							préconisé.
						</FormHelperText>
					</Stack>
				)}
			</PaperDialog>
		</FormProvider>
	);
}
